import { TFunction } from "i18next";
import { getAuthItems } from "../auth/AuthItems";

export const enum Country {
  AR = "AR",
  AT = "AT",
  AU = "AU",
  BE = "BE",
  BG = "BG",
  BR = "BR",
  CA = "CA",
  CH = "CH",
  CZ = "CZ",
  DE = "DE",
  DK = "DK",
  ES = "ES",
  FI = "FI",
  FR = "FR",
  GB = "GB",
  GR = "GR",
  HK = "HK",
  HU = "HU",
  ID = "ID",
  IE = "IE",
  IN = "IN",
  IT = "IT",
  JP = "JP",
  KH = "KH",
  KR = "KR",
  LA = "LA",
  LU = "LU",
  MX = "MX",
  MY = "MY",
  NL = "NL",
  NO = "NO",
  NZ = "NZ",
  PH = "PH",
  PK = "PK",
  PL = "PL",
  PT = "PT",
  RO = "RO",
  RU = "RU",
  SE = "SE",
  SG = "SG",
  SK = "SK",
  TH = "TH",
  TR = "TR",
  TW = "TW",
  US = "US",
  VN = "VN",
}

export const getCompatibleCountry = (t: TFunction, targetCountryName: string | undefined) => {
  const countryList = setCountryList(t);

  if (!countryList) {
    return [];
  }
  if (!targetCountryName) {
    return countryList;
  }
  return countryList.filter((item) => {
    if (item.value === targetCountryName) {
      return item.value;
    }
  });
};

export const getCompatibleState = (targetCountry: string, targetStateName?: string) => {
  const stateList = getStateList(targetCountry);

  if (!stateList) {
    return [{ label: "", value: "" }];
  }
  if (!targetStateName) {
    return stateList;
  }
  return stateList.filter((item) => {
    if (item.value === targetStateName) {
      return item.value;
    }
  });
};

export const convertStateValue = (targetCountry: string, fullStateName: string) => {
  if (getAuthItems().loginPole !== "RUS") {
    return "";
  }

  const stateList = getStateList(targetCountry);

  if (!stateList) {
    return "";
  }
  const hitState = stateList.filter((item) => {
    if (item.label === fullStateName) {
      return item.value;
    }
  });
  if (!hitState) {
    return "";
  }
  return hitState[0].value;
};

const setCountryList = (t: TFunction) => {
  const REcountryList = [
    { label: t("country.AT"), value: Country.AT },
    { label: t("country.BE"), value: Country.BE },
    { label: t("country.BG"), value: Country.BG },
    { label: t("country.CH"), value: Country.CH },
    { label: t("country.CZ"), value: Country.CZ },
    { label: t("country.DE"), value: Country.DE },
    { label: t("country.DK"), value: Country.DK },
    { label: t("country.ES"), value: Country.ES },
    { label: t("country.FI"), value: Country.FI },
    { label: t("country.FR"), value: Country.FR },
    { label: t("country.GB"), value: Country.GB },
    { label: t("country.GR"), value: Country.GR },
    { label: t("country.HU"), value: Country.HU },
    { label: t("country.IE"), value: Country.IE },
    { label: t("country.IT"), value: Country.IT },
    { label: t("country.LU"), value: Country.LU },
    { label: t("country.NL"), value: Country.NL },
    { label: t("country.NO"), value: Country.NO },
    { label: t("country.PK"), value: Country.PK },
    { label: t("country.PL"), value: Country.PL },
    { label: t("country.PT"), value: Country.PT },
    { label: t("country.RO"), value: Country.RO },
    { label: t("country.RU"), value: Country.RU },
    { label: t("country.SE"), value: Country.SE },
    { label: t("country.SK"), value: Country.SK },
    { label: t("country.TR"), value: Country.TR },
  ];
  const RJcountryList = [{ label: t("country.JP"), value: Country.JP }];
  const RUScountryList = [
    { label: t("country.CA"), value: Country.CA },
    { label: t("country.US"), value: Country.US },
  ];
  const RLAcountryList = [
    { label: t("country.AR"), value: Country.AR },
    { label: t("country.BR"), value: Country.BR },
    { label: t("country.MX"), value: Country.MX },
  ];
  const RAPcountryList = [
    { label: t("country.AU"), value: Country.AU },
    { label: t("country.HK"), value: Country.HK },
    { label: t("country.ID"), value: Country.ID },
    { label: t("country.IN"), value: Country.IN },
    { label: t("country.KH"), value: Country.KH },
    { label: t("country.LA"), value: Country.LA },
    { label: t("country.MY"), value: Country.MY },
    { label: t("country.NZ"), value: Country.NZ },
    { label: t("country.PH"), value: Country.PH },
    { label: t("country.SG"), value: Country.SG },
    { label: t("country.TH"), value: Country.TH },
    { label: t("country.TW"), value: Country.TW },
    { label: t("country.VN"), value: Country.VN },
  ];
  const RKRcountryList = [{ label: t("country.KR"), value: Country.KR }];

  const authItems = getAuthItems();
  const tenantPole = authItems.loginPole;

  switch (tenantPole) {
    case "RE":
      return REcountryList;
    case "RJ":
      return RJcountryList;
    case "RUS":
      return RUScountryList;
    case "RLA":
      return RLAcountryList;
    case "RAP":
      return RAPcountryList;
    case "RKR":
      return RKRcountryList;
  }
};

// 北米極のみで使うものなので、多言語対応はしない
const US_STATE_LIST = [
  { label: "Armed Forces America", value: "AA" },
  { label: "Armed Forces", value: "AE" },
  { label: "Alaska", value: "AK" },
  { label: "Alabama", value: "AL" },
  { label: "Armed Forces Pacific", value: "AP" },
  { label: "Arkansas", value: "AR" },
  { label: "American Samoa", value: "AS" },
  { label: "Arizona", value: "AZ" },
  { label: "California", value: "CA" },
  { label: "Colorado", value: "CO" },
  { label: "Connecticut", value: "CT" },
  { label: "Washington DC", value: "DC" },
  { label: "Delaware", value: "DE" },
  { label: "Florida", value: "FL" },
  { label: "Georgia", value: "GA" },
  { label: "Guam", value: "GU" },
  { label: "Hawaii", value: "HI" },
  { label: "Iowa", value: "IA" },
  { label: "Idaho", value: "ID" },
  { label: "Illinois", value: "IL" },
  { label: "Indiana", value: "IN" },
  { label: "Kansas", value: "KS" },
  { label: "Kentucky", value: "KY" },
  { label: "Louisiana", value: "LA" },
  { label: "Massachusetts", value: "MA" },
  { label: "Maryland", value: "MD" },
  { label: "Maine", value: "ME" },
  { label: "Michigan", value: "MI" },
  { label: "Minnesota", value: "MN" },
  { label: "Missouri", value: "MO" },
  { label: "Mississippi", value: "MS" },
  { label: "Montana", value: "MT" },
  { label: "North Carolina", value: "NC" },
  { label: "North Dakota", value: "ND" },
  { label: "Nebraska", value: "NE" },
  { label: "New Hampshire", value: "NH" },
  { label: "New Jersey", value: "NJ" },
  { label: "New Mexico", value: "NM" },
  { label: "Nevada", value: "NV" },
  { label: "New York", value: "NY" },
  { label: "Ohio", value: "OH" },
  { label: "Oklahoma", value: "OK" },
  { label: "Oregon", value: "OR" },
  { label: "Pennsylvania", value: "PA" },
  { label: "Puerto Rico", value: "PR" },
  { label: "Rhode Island", value: "RI" },
  { label: "South Carolina", value: "SC" },
  { label: "South Dakota", value: "SD" },
  { label: "Tennessee", value: "TN" },
  { label: "Texas", value: "TX" },
  { label: "Utah", value: "UT" },
  { label: "Virginia", value: "VA" },
  { label: "Virgin Islands", value: "VI" },
  { label: "Vermont", value: "VT" },
  { label: "Washington", value: "WA" },
  { label: "Wisconsin", value: "WI" },
  { label: "West Virginia", value: "WV" },
  { label: "Wyoming", value: "WY" },
];

// 北米極のみで使うものなので、多言語対応はしない
const CA_STATE_LIST = [
  { label: "Alberta", value: "AB" },
  { label: "British Columbia", value: "BC" },
  { label: "Manitoba", value: "MB" },
  { label: "New Brunswick", value: "NB" },
  { label: "Newfoundland and Labrador", value: "NL" },
  { label: "Nova Scotia", value: "NS" },
  { label: "Northwest Territories", value: "NT" },
  { label: "Nunavut", value: "NU" },
  { label: "Ontario", value: "ON" },
  { label: "Prince Edward Island", value: "PE" },
  { label: "Quebec", value: "QC" },
  { label: "Saskatchewan", value: "SK" },
  { label: "Yukon", value: "YT" },
];

const COUNTRY_STATE = { US: US_STATE_LIST, CA: CA_STATE_LIST };

const getStateList = (targetCountry: string) => {
  if (targetCountry === "US" || targetCountry === "CA") {
    return COUNTRY_STATE[targetCountry];
  }
  return [];
};
